import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Product } from 'src/app/models/app.models';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReviewRatingService } from 'src/app/services/review-rating.service';
import { OutOfStockService } from 'src/app/services/out-of-stock.service';
import { Constant } from 'src/app/constants/constant';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { AboutService } from 'src/app/services/about.service';
import { CommonService } from 'src/app/services/common.service';
import { CommonSignInComponent } from 'src/app/shared/CommonSignIn/CommonSignIn.component';
import { AnalyticService } from 'src/app/services/analytic-service';

@Component({
  selector: 'calsoft-product-type9',
  templateUrl: './product-type9.component.html',
  styleUrls: ['./product-type9.component.scss']
})
export class ProductType9Component {
  @Input() sizeChartId: any;
  @Input() productDetailHeightMobile: any;
  @Input() productDetailWidthMobile: any;
  @Input() productDetailHeight: any;
  @Input() productDetailWidth: any;
  @Input() productDetailPage: any;

  @Input() data: any;

  @Input() name: any;

  @Input() response: any;

  @Input() MapLink: any;

  @Input() reviewDetail: any

  @Input() relatedProductsList: any;

  @Input() upSellsProductsList: any;

  @Input() crossSellsProductsList: any

  @Input() recentlyViewedProducts: any;

  @Input() displayColdChain: boolean;
  @Input() deliveryDoorStepIcon: any;
  @Input() showTimeIcon: any;
  @Input() showGenuineProductIcon: any;
  @Input() genuineProductText: any;
  @Input() deliveryTime: any;
  @Input() deliveryDoorStepText: any;
  @Input() ColdChain: any;
  @Input() product: any;
  @Input() guestLogin: any;
  @Input() videourl: any;
  @Input() videoAvaliable: boolean;
  @Input() isInStock: any;
  @Input() qty: any;
  @Input() manageStock: any;

  @Input() factBox: any;
  @Input() faq: any;
  @Input() SIDEEFFECTS: any;
  @Input() Commonsideeffects: any;
  @Input() SafetyAdvice: any;
  @Input() HOWTOUSE: any;
  @Input() UsesOf: any;
  @Input() Benefits: any;
  @Input() HowWorks: any;
  @Input() Ifmiss: any;
  @Input() productName: any;
  @Input() PregnancyInteraction: any;
  @Input() BreastfeedingInteraction: any;
  @Input() DrivingInteraction: any;
  @Input() KidneyInteraction: any;
  @Input() LiverInteraction: any;
  @Input() MANUFACTURER: any;
  @Input() SALTCOMPOSITION: any;
  @Input() STORAGES: any;
  @Input() factbox: any;
  @Input() spec: any;
  @Input() showNewConfig: boolean = false;
  @Input() units: any;
  @Input() discountPercentage: any;
  @Input() price: number;
  @Input() specialPrice: any;
  @Input() averageRating: any;
  @Input() calculateAvgRating: any
  @Input() prescriptionRequired: boolean = false;
  @Input() imageList: any;
  @Input() productDetailImageWidth: any;
  @Input() productzoom: any;
  @Input() productIdAddedInCart: any = {};
  @Input() configattributeType: any;
  @Input() firstIndex: any;
  @Input() secondIndex: any;
  @Input() configurationDropDownList = new Map<any, any>();
  @Input() dropDownValue = new UntypedFormControl('');
  @Input() configProductSelected: any;
  @Input() configProduct: any;
  @Input() showExclusivePrice: number;
  @Input() managePriceSeperately: number;
  @Input() maintainStockIndConfProduct: number;
  @Input() manageAdditionalInformationSeperately: number;
  @Input() manageDescriptionSeperately: number;
  @Input() manageNameSeperately: number;
  @Input() description: any;
  @Input() manageImageSeperately: number;
  @Input() bigImage: string;
  @Input() alcoholInteraction: any;
  @Input() commonImageApi: any;
  @Input() shortDescription: any;
  @Input() relatedProductsText: any;
  @Input() upSellProductsText: any;
  @Input() crossSellProductsText: any;
  @Input() recentlyViewedProductsText: any;
  @Input() showCartIcon: any;
  @Input() showCartIncremented: any;
  @Input() categoryArray: any;
  @Input() indexConfig: any = 0;
  @Input() productImageWidth: any;
  @Input() productImageType: any;
  @Input() productImageWidthMob: any;
  @Input() productImageHeightMob: any;
  @Input() productImageHeight: any;
  @Input() showConfigurableDropdown: any;
  @Input() coversionTrackingIdGa:any;
  
  enableEnquire: any = 0;
  disablePriceInDetailPage: any = 1;

  @Input() buttonArray: any = [];

  @ViewChild('shareProduct') shareProduct: TemplateRef<any>;

  @ViewChild('zoomViewer', { static: true }) zoomViewer;

  @Input() image: any;
  @Input() zoomImage: any;
  @Input() sub: any;
  @Input() form: UntypedFormGroup;
  @Input() relatedProducts: Array<Product>;
  @Input() filterRequest: any;
  @Input() images: Object;
  @Input() query: any;
  @Input() documentId: any;
  @Input() configurableProductId: any;

  @Input() productDetailPageSubimageHeight:any;

  @Input() event: any;

  b2bPricingEnabled: string | number;


  public ProductDetailsMainSliderConfig: any = ProductDetailsMainSlider;

  public ProductDetailsThumbConfig: any = ProductDetailsThumbSlider;


  public serverPath7 = environment.commonImageApi+"catalog/product";
  Layout: any;
  pageTitle: any;
  layoutype: any;
  homePageBuilder: any;
  init: boolean;
  page1: any;

  constructor(
    private commonService:CommonService,
    private activatedRoute: ActivatedRoute,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar,
    public title: Title, public meta: Meta,
    private reviewService: ReviewRatingService,
    private outOfStockService: OutOfStockService,
    private dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private userService: UserService,
    private aboutService: AboutService,
    private analyticService: AnalyticService,
  ) { }
  form_validation_messages = {

    'phone': [
      { type: 'required', message: 'Please fill out this field.' },
      { type: 'minlength', message: 'Enter a Valid Number' },
      { type: 'maxlength', message: 'Enter a Valid Number' },
    ],

    }
  ngOnInit(): void {

    this.productDetailImageWidth = 50;

    if(this.name==undefined){
      this.name='';
    }
    
    this.productIdAddedInCart = this.product;
    this.textAccount = 'OK';
    this.productName = this.name;

    if (this.configProductSelected['isCustomizedValue'] != null) {
      if (this.configProductSelected['isCustomizedValue']['Layout'] != null) {
        this.Layout = this.configProductSelected['isCustomizedValue']['Layout'];

      }
    }


    this.pageTitle = this.Layout

    if(this.Layout!=null){
      this.getAboutData();
    }

  }


  getAboutData() {

    this.aboutService.getPageById(this.pageTitle).subscribe(
      (res) => {
        this.layoutype = res['type'];
        this.homePageBuilder = res['homePageBuilder'];
        this.init = true;

      }
    )
  }

  facebook() {
    let url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location.href)
    'facebook-share-dialog'
    this.commonService.goToLink(url);

  }

  whatsapp() {
    let currentURL = window.location.href
    let encodedURL = encodeURIComponent(currentURL); // Encode the URL
    let url = `https://api.whatsapp.com/send?text=${encodedURL}`;
    this.analyticService.customEventEmitter('WA_button_Clicked', 'BUTTON_CLICK',
      'Whats App Click', url)
    this.commonService.goToLink(url);
  }

  copy() {
    let currentURL = window.location.href
    this.clipboard.copy(`${currentURL}`);
    this.snackBar.open(`Copied `, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
  }

  public onMouseMove(e) {


    if (window.innerWidth >= 1280) {
      var image, offsetX, offsetY, x, y, zoomer;
      image = e.currentTarget;
      offsetX = e.offsetX;
      offsetY = e.offsetY;
      x = offsetX / image.offsetWidth * 100;
      y = offsetY / image.offsetHeight * 100;
      zoomer = this.zoomViewer.nativeElement.children[0];
      if (zoomer) {
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
        zoomer.style.display = "block";
        zoomer.style.height = image.height + 'px';
        zoomer.style.width = image.width + 'px';
      }
    }
  }

  public onMouseLeave(event) {
    this.zoomViewer.nativeElement.children[0].style.display = "none";
  }

  getConfigProductIdNew(event, i, value, index) {
    if (event.isUserInput != false) {
      this[index] = i;
      this.configurableProductId = this.configurationDropDownList[this.firstIndex]
      ['recursuive'][this.secondIndex].productId;
      this.configProductSelected = JSON.parse(this.configProduct[this.configurableProductId]);
      this.setConfigProductItem();
    }
  }


  setConfigProductItem() {

    if(this.product['type'] == "Configurable"){
      this.getProductDetailReviewId(this.configurableProductId);
      }
      if(this.product['type'] == "Variants"){

        this.getProductDetailReviewIdAndSubId(this.configurableProductId,this.product.entityId);
      }

    if (this.showExclusivePrice == 1) {
      if (this.configurableProductId['isCustomizedValue'] != null) {
        if (this.configurableProductId['isCustomizedValue']
        ['specialPriceWithoutTaxamount'] != null) {
          this.specialPrice = this.configurableProductId['isCustomizedValue']
          ['specialPriceWithoutTaxamount'];
        }
        if (this.configurableProductId['isCustomizedValue']
        ['priceWithoutTaxamount'] != null) {
          this.price = this.configurableProductId['isCustomizedValue']
          ['priceWithoutTaxamount'];
        }
      }
    }
    if (this.managePriceSeperately == 1) {
      this.price = this.configProductSelected['price'];
      this.specialPrice = this.configProductSelected['specialPrice'];
      this.discountPercentage = this.configProductSelected['discountPercentage'];

         
      if (this.configProductSelected['isCustomizedValue'] != null) {
        this.b2bPricingEnabled=localStorage.getItem(Constant.B2B_USER)==null?0:localStorage.getItem(Constant.B2B_USER);
        if(this.b2bPricingEnabled==0){
          this.price = this.configProductSelected['price'];
          this.specialPrice = this.configProductSelected['specialPrice'];
        }else{
  
          if(this.configProductSelected['isCustomizedValue']['Whole Sale Price']!=undefined){
  
          
          this.price = this.configProductSelected['isCustomizedValue']['Whole Sale Price'];
          this.specialPrice = this.configProductSelected['isCustomizedValue']['Whole Sale Discount Price'];
       
          if (Number.isNaN(this.configProductSelected['isCustomizedValue']['Whole Sale Discount Percentage'])){
            this.discountPercentage =0.0;
          }
        
          else if(this.configProductSelected['isCustomizedValue']['Whole Sale Discount Percentage']!=null){
            this.discountPercentage = parseFloat(this.configProductSelected['isCustomizedValue']['Whole Sale Discount Percentage']);
          }else{
            this.discountPercentage =0.0;
          }
          if(this.price==0.0){
            this.price=this.configProductSelected['price']
            this.specialPrice=this.configProductSelected['specialPrice']
            this.discountPercentage=this.configProductSelected['discountPercentage']
          }    
        }
        }
      }
    }


    if (this.maintainStockIndConfProduct == 1) {
      this.qty = this.configProductSelected['qty'];
      this.manageStock = this.configProductSelected['manageStock'];
      this.isInStock = this.configProductSelected['isInStock'];
      this.productIdAddedInCart = this.configProductSelected;
      this.averageRating = this.configProductSelected['averageRating'];
      this.calculateAvgRating = this.configProductSelected['calculateAvgRating'];

    }


    if (this.manageAdditionalInformationSeperately == 1) {
      this.spec = this.configProductSelected['additionalSpec'];
    }


    if (this.manageDescriptionSeperately == 1) {
      this.description = this.configProductSelected['description'];
    }

    if (this.manageNameSeperately == 1) {
      this.name = this.configProductSelected['name'];
    }

    if (this.manageImageSeperately == 1) {

        if (this.configProductSelected['productImageUrl'] != 'no_selection') {
          if(this.configProductSelected['productImageUrl'].includes('http')){
            this.image =  this.configProductSelected['productImageUrl'];
            this.zoomImage =  this.configProductSelected['productImageUrl'];
          } else if (this.configProductSelected['productImageUrl'].includes("medicineimages")) {
            this.image = this.commonImageApi + this.configProductSelected['productImageUrl'];
            this.zoomImage = this.commonImageApi + "/" + this.configProductSelected['productImageUrl'];
          } else if (this.configProductSelected['productImageUrl'].includes("commonimages")) {
            this.image = this.serverPath7 + this.configProductSelected['productImageUrl'];
            this.zoomImage = this.serverPath7 + "/" + this.configProductSelected['productImageUrl'];
          }
          else{
            this.image = this.bigImage + "/" + this.configProductSelected['productImageUrl'];
            this.zoomImage = this.bigImage + "/" + this.configProductSelected['productImageUrl'];
          }
        } else {
          this.image = this.configProductSelected['productImageUrl'];
          this.zoomImage = this.configProductSelected['productImageUrl'];
        }
       
        this.imageList = this.configProductSelected['images'];
  
        if (this.imageList == null) {
          this.imageList = []
        }
        if(this.imageList[0]==undefined){
          this.image="assets/images/products/noImage/no-image.png";
          this.zoomImage="assets/images/products/noImage/no-image.png";
        }
      
    }
  }

  getProductDetailReviewIdAndSubId(productId,subProductId) {
    this.reviewService.getProductDetailReviewVariant(productId,subProductId)
      .subscribe(
        data => {
          this.reviewDetail = data;
        },
        error => {
        }
      );
  }

  getProductDetailReviewId(productId) {
    this.reviewService.getProductDetailReviewAll(productId)
      .subscribe(
        data => {
          this.reviewDetail = data;
        },
        error => {
        }
      );
  }

  setZoomImage(event) {
    this.zoomImage = event

  }

  getConfigProductId(event, index) {

    this.firstIndex = index;
    //  let value = event.split("#")[0];
    if (event.includes(",")) {
      event = event.split(",")[0];
    }
    this.configurableProductId = event.split("#")[1];
    this.configProductSelected = JSON.parse(this.configProduct[this.configurableProductId]);
    this.dropDownValue.patchValue(event);
    this.setConfigProductItem();
  }

  getConfigProductIdButton(i, index) {

    this[index] = i;
    this.configurableProductId = this.configurationDropDownList[this.firstIndex]
    ['recursuive'][this.secondIndex].productId;
    this.configProductSelected = JSON.parse(this.configProduct[this.configurableProductId]);
    this.setConfigProductItem();

  }
  getImageproductId(productId) {

    let value = JSON.parse(this.configProduct[productId]);
    if(value.productImageUrl!=undefined){
     
    if (value.productImageUrl.includes("http")) {
      return  value.productImageUrl;
       
     }
     else if (value.productImageUrl.includes("medicineimages")) {
       return   this.commonImageApi + value.productImageUrl;
      
     }  else if (value.productImageUrl.includes("commonimages")) {
      return   this.serverPath7 + value.productImageUrl;
     
    }else {
       return  this.bigImage + "/" + value.productImageUrl;
      
     }
    }else{
      return value.productImageUrl
    }
    
    
    
  }

  generateWhatsAppMessage() {

    let message = `Hi, I'm interested in buying the ${this.product.name}.\n`;
    message += `Can you please provide more information about it, including the price?`;
    const url = `https://api.whatsapp.com/send?phone= ${encodeURIComponent(this.data.storePhoneNumber)}&text=${encodeURIComponent(message)}`;
    this.commonService.goToLink(url);
  }

  // notify


  createNotify(object, url) {

    this.outOfStockService.outOfStockNotification(object, url).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });

        }
        else {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      (err) => { });

  }

  @ViewChild('notify') notify: TemplateRef<any>;

  initOutStockFunction() {
    let authourized = this.userService.getAuthenticatedUser();
    let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN'])
    if (guestLoginEnabled == "0" && authourized==null) {
      this.loginModel();
    }else if (guestLoginEnabled == "0" || authourized) {
      let object = {
        'productId': this.product['entityId'],
        'productName': this.name,
        'guest': 0,
      }
      let url = '/outofstocknotification/web';
      this.createNotify(object, url);
    } else {
      let dialogRef = this.dialog.open(this.notify, {
        width: '500px',
        disableClose: true,
      });
      dialogRef.disableClose = true;
    }

  }


  loginModel() {
		if (window.innerWidth > 768) {
	
		  let dialogRef = this.dialog.open(CommonSignInComponent, {
			width: '790px',
			data: { page: this.page1, }
		  });
	
		  dialogRef.disableClose = true;
		  dialogRef.afterClosed().subscribe(result => {
			this.ngOnInit();
	
	
		  });
	
		}
		else {
		  let dialogRef = this.dialog.open(CommonSignInComponent, {
			minWidth: '100vw', height: '100vh',
			data: { page: this.page1, }
		  });
	
		  dialogRef.disableClose = true;
		  dialogRef.afterClosed().subscribe(result => {
			this.ngOnInit();
	
	
		  });
		}
	
	  }
    noWhitespaceValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { whitespace: true };
      };
    }


    secondFormGroup = this._formBuilder.group({
      customerName: ['', [Validators.required, this.noWhitespaceValidator()]],    
        email: ['', [Validators.required, Validators.email]], 
      phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]] 
    });
    


  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  textAccount: string;

  submitOutOfStockPopup() {

    if (this.secondFormGroup.valid) {
      this.dialog.closeAll();
      let url = '/ig/outofstocknotification/web';
      let object = {
        'productId': this.product['entityId'],
        'productName': this.name,
        'customerName': this.secondFormGroup.value['customerName'],
        'customerEmail': this.secondFormGroup.value['email'],
        'customerPhoneNumber': this.secondFormGroup.value['phone'],
        'guest': 1,
        'customerId': 0
      }
      this.createNotify(object, url);
    }
    else {
      this.validateAllFormFields(this.secondFormGroup);

    }

  }
  getImageproductIdOld(event) {

    let productId = event.split("#")[1];
    let value = JSON.parse(this.configProduct[productId]);

    if (value.productImageUrl.includes("http")) {
      return  value.productImageUrl;
       
     }
     else if (value.productImageUrl.includes("medicineimages")) {
       return   this.commonImageApi + value.productImageUrl;
      
     }  else if (value.productImageUrl.includes("commonimages")) {
      return   this.serverPath7 + value.productImageUrl;
     
    }else {
       return  this.bigImage + "/" + value.productImageUrl;
      
     }
    
  }


  getDirections(MapLink:string): void{
    if (MapLink && MapLink.toLowerCase() !== 'none') {
      let url = MapLink.toLowerCase();
      
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'http://' + url;
      }
  
      this.commonService.goToLink(url);

    }

  }

}


export let ProductDetailsMainSlider: any = {
  items: 1,
  nav: false,
  dots:false,
  autoplay: false,
  slideSpeed: 300,
  loop: true
}


export let ProductDetailsThumbSlider: any = {
  items: 3,
  loop: true,
  margin: 10,
  dots:false
}
